import { MstGraphType, thresholdType, rangeType, MstMappingType, MstSeatMappingType, SensorStateType, SeatSensorStateType } from "../../types/types";

export default class MakeInputBody {
  public static make(mstGraphData: MstGraphType) {
    return `
      user_id: "${mstGraphData.user_id}",
      graph_id: ${mstGraphData.graph_id},
      lineType: "${mstGraphData.lineType}",
      authStoreName: "${mstGraphData.authStoreName}",
      updateInterval: "${mstGraphData.updateInterval}",
      partitionKey: "${mstGraphData.partitionKey}",
      partitionKeyType: "${mstGraphData.partitionKeyType}",
      sortKey: "${mstGraphData.sortKey}",
      sortKeyType: "${mstGraphData.sortKeyType}",
      drawRange: "${mstGraphData.drawRange}",
      targetAttribute: "${mstGraphData.targetAttribute}",
      targetAttributes: ${MakeInputBody.makeArrayBody(
        mstGraphData.targetAttributes,
      )},
      targetPartitionKey: "${mstGraphData.targetPartitionKey}",
      timeFormat: "${mstGraphData.timeFormat}",
      orgTimeFormat: "${mstGraphData.orgTimeFormat}",
      dataTimezone: "${mstGraphData.dataTimezone}",
      partitions: ${MakeInputBody.makeArrayBody(mstGraphData.partitions)},
      attributes: ${MakeInputBody.makeArrayBody(mstGraphData.attributes)},
      graphTitle: "${mstGraphData.graphTitle}",
      mails: ${MakeInputBody.makeArrayBody(mstGraphData.mails)},
      table: "${mstGraphData.table}",
      threshold: ${MakeInputBody.makeThresholdBody(mstGraphData.threshold)},
      thresholdSettings: ${JSON.stringify(mstGraphData.thresholdSettings)},
      range: ${MakeInputBody.makeRangeBody(mstGraphData.range)},
      graphDateFormat: "${mstGraphData.graphDateFormat}",
      changeAlertSwitch: ${mstGraphData.changeAlertSwitch},
      thresholdSettingsList: ${MakeInputBody.makeArrayBody(mstGraphData.thresholdSettingsList)}
    `;
  }

  public static makeMappingBody(mstMappingData: MstMappingType) {
    const sensorState: SensorStateType = mstMappingData.sensor_state as SensorStateType;
    return `
      user_id: "${mstMappingData.user_id}",
      mapping_id: ${mstMappingData.mapping_id},
      mst_signallamp_id: ${mstMappingData.mst_signallamp_id},
      mst_graph_id: ${mstMappingData.mst_graph_id},
      sensor_state: {
        displayName: "${sensorState.displayName}",
        targetAttribute: "${sensorState.targetAttribute}",
        xPosition: ${sensorState.xPosition}
        yPosition: ${sensorState.yPosition}
        width: ${sensorState.width}
        height: ${sensorState.height}
      }
    `;
  }

  public static makeSeatMappingBody(mstSeatMappingData: MstSeatMappingType) {
    const sensorState: SeatSensorStateType = mstSeatMappingData.sensor_state as SeatSensorStateType;
    return `
      user_id: "${mstSeatMappingData.user_id}",
      mapping_id: ${mstSeatMappingData.mapping_id},
      device_id: "${mstSeatMappingData.device_id}",
      sensor_state: {
        displayName: "${sensorState.displayName}",
        xPosition: ${sensorState.xPosition}
        yPosition: ${sensorState.yPosition}
        width: ${sensorState.width}
        height: ${sensorState.height}
      }
    `;
  }

  /**
   * 配列用生成用
   * @param array
   */
  private static makeArrayBody(array: any[]) {
    let returnBody: string = "[";
    for (let i = 0; i < array.length; i++) {
      returnBody = `${returnBody}"${array[i]}"`;
      if (i !== array.length - 1) {
        returnBody += ",";
      }
    }
    return returnBody + "]";
  }

  /**
   * threshold生成用
   * @param threshold
   */
  private static makeThresholdBody(threshold: thresholdType) {
    return `{
      min: {
        enabled: ${threshold.min.enabled}
        value: ${threshold.min.value}
      },
      max: {
        enabled: ${threshold.max.enabled}
        value: ${threshold.max.value}
      }
    }`;
  }

  /**
   * range生成用
   * @param range
   */
  private static makeRangeBody(range: rangeType) {
    return `{
      enabled: ${range.enabled},
      min: ${range.min},
      max: ${range.max}
    }`;
  }
}
